var ɵ0 = {
    wdprConversationCookieName: 'Conversation_UUID',
    wdprConversationHeader: 'X-Conversation-Id',
    wdprCorrelationHeader: 'X-Correlation-Id',
    wdprEndpointFilter: '(/error/?|homepage-banner-toggles\.json)'
};
var CoreModule = /** @class */ (function () {
    function CoreModule() {
    }
    return CoreModule;
}());
export { CoreModule };
export { ɵ0 };
